import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quillNoteType'
})
export class QuillNoteTypePipe implements PipeTransform {

  transform(value: string): 'object' | 'json' | 'html' | 'text' {
    console.log(value);
    if(typeof value === 'object') return 'object';
    if(typeof value !== 'string' || value.length < 5) return 'text';
    if(value.startsWith('{"ops":[{')) return 'json';
    if(value.startsWith('<')) return 'html';
    return 'text';
  }

}
